import styled from 'styled-components';
import { theme, media } from '../../styles/theme';

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  padding: ${({ size }) => {
    if (size === 'sm') return '0.5rem 1rem';
    if (size === 'lg') return '0.875rem 2rem';
    return '0.75rem 1.5rem';
  }};
  font-size: ${({ size }) => {
    if (size === 'sm') return theme.typography.fontSize.sm;
    if (size === 'lg') return theme.typography.fontSize.base;
    return theme.typography.fontSize.base;
  }};
  font-weight: ${theme.typography.fontWeight.semiBold};
  border-radius: ${theme.borderRadius.md};
  transition: all ${theme.transitions.duration.base} ${theme.transitions.easing.easeOut};
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  z-index: 1;
  min-height: ${({ size }) => {
    if (size === 'sm') return '36px';
    if (size === 'lg') return '48px';
    return '44px';
  }};

  /* Ripple effect */
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
    pointer-events: none;
    z-index: 0;
  }

  &:active::after {
    width: 300px;
    height: 300px;
  }

  ${({ variant }) => {
    if (variant === 'primary') {
      return `
        background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryLight} 100%);
        color: ${theme.colors.white};
        box-shadow: 0 4px 6px ${theme.colors.primary}30;
        
        &:hover {
          background: linear-gradient(135deg, ${theme.colors.primaryLight} 0%, ${theme.colors.primary} 100%);
          box-shadow: 0 6px 12px ${theme.colors.primary}40;
          transform: translateY(-2px);
        }
        
        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 4px ${theme.colors.primary}30;
        }
      `;
    }
    if (variant === 'secondary') {
      return `
        background-color: ${theme.colors.secondary};
        color: ${theme.colors.text};
        border: 1px solid ${theme.colors.border};
        
        &:hover {
          background-color: ${theme.colors.secondaryDark};
          border-color: ${theme.colors.primary}40;
          transform: translateY(-1px);
          box-shadow: ${theme.shadows.sm};
        }
        
        &:active {
          transform: translateY(0);
        }
      `;
    }
    if (variant === 'accent') {
      return `
        background: linear-gradient(135deg, ${theme.colors.accent} 0%, #FF8C5A 100%);
        color: ${theme.colors.white};
        box-shadow: 0 4px 6px ${theme.colors.accent}30;
        
        &:hover {
          opacity: 0.95;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px ${theme.colors.accent}40;
        }
        
        &:active {
          transform: translateY(0);
        }
      `;
    }
    if (variant === 'outline') {
      return `
        background-color: transparent;
        color: ${theme.colors.primary};
        border: 2px solid ${theme.colors.primary};
        
        &:hover {
          background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryLight} 100%);
          color: ${theme.colors.white};
          transform: translateY(-2px);
          box-shadow: ${theme.shadows.md};
        }
        
        &:active {
          transform: translateY(0);
        }
      `;
    }
    return `
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.text};
      border: 1px solid ${theme.colors.border};
      
      &:hover {
        background-color: ${theme.colors.secondaryDark};
      }
    `;
  }}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
    
    &:hover {
      transform: none !important;
    }
  }

  ${({ fullWidth }) => fullWidth && 'width: 100%;'}

  ${media.down.sm} {
    font-size: ${theme.typography.fontSize.sm};
    padding: ${({ size }) => {
      if (size === 'sm') return '0.4rem 0.8rem';
      if (size === 'lg') return '0.75rem 1.5rem';
      return '0.65rem 1.2rem';
    }};
  }
`;

